import DuckEntity from './DuckEntity';

const entity = new DuckEntity('combinedEnrollmentTotalsReport', {
  apiPath: 'reporting/combined_enrollment_total_report',
  jsonRoot: 'combined_enrollment_total_report',
  jsonIndexRoot: 'combined_enrollment_total_report'
});
export default entity.reducer;
export { entity };
